import { createApp } from 'vue'

// global css
import 'element-plus/dist/index.css'
import './assembly/rem.js'
import '@/assets/styles/base.scss'
import '@/assets/fonts/iconfonts/iconfont.css'

// App、router、store
import App from './App.vue'
import store from './store'
import router from './router'

import { download } from '@/utils/request'

// permission control
import './permission'
import { parseTime, addDateRange, handleTree, selectDictLabel, selectDictLabels } from '@/utils/ruoyi'

// 国际化
import i18n from '@/lang/index'
import { injectComponent } from './utils/injectComponent'

const app = createApp(App)

// 全局方法挂载
app.config.globalProperties.download = download
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabel

injectComponent(app)
app.use(router)
app.use(store)
app.use(i18n)

app.use(aapaas.injectVue, {
  dev: __DEV__,
  baseApi: __DEV_BASE_API__
})

app.mount('#app')
